import smoothscroll from 'smoothscroll-polyfill';
//import aos from './aos';

import handleCursor from './handleCursor';
import handleHeader from './handleHeader';
import handleHero from './handleHero';
import handleSwiper from './handleSwiper';
import handleOfferBtn from './handleOfferBtn';
import handleMobileSubmenu from './handleMobileSubmenu';
import handleShuffle from './handleShuffle';
import handleContact from './handleContact';
import handleAccordion from './handleAccordion';
import handleForm from './handleForm';
import handleLangMenu from './handleLangMenu';
import handleYear from './handleYear';
import handleGoTop from './handleGoTop';
import handleScroll from './handleScroll';
import handleWordCount from './handleWordCount';

window.addEventListener('DOMContentLoaded', () => {
  handleHeader();
  handleHero();
  handleSwiper();
  handleCursor();
  handleOfferBtn();
  handleMobileSubmenu();
  handleShuffle();
  handleContact();
  handleAccordion();
  handleForm();
  handleLangMenu();
  handleYear();
  handleGoTop();
  handleScroll();
  handleWordCount();

  //aos();
  smoothscroll.polyfill();
});
